import React, { useState } from "react";
import { useApp } from "../store";
import { ErrorNote, Note } from "../ui";

/** Sign in or register. Registration always creates a regular user; admins are seeded. */
export function LoginPage(): JSX.Element {
  const { login, register } = useApp();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [email, setEmail] = useState("anders@talklight.test");
  const [password, setPassword] = useState("talklight-demo");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === "login") {
        await login(email, password);
      } else {
        await register(email, password, displayName || email);
      }
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <header className="app-header">
        <h1>Talklight</h1>
      </header>
      <div className="content">
        <Note>
          PSTN calling and messaging on numbers you own. Each number is its own subscription.
        </Note>
        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              autoComplete="username"
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {mode === "register" ? (
            <div className="field">
              <label htmlFor="displayName">Name</label>
              <input
                id="displayName"
                value={displayName}
                onChange={(event) => setDisplayName(event.target.value)}
              />
            </div>
          ) : null}
          <ErrorNote error={error} />
          <button className="btn primary" type="submit" disabled={busy}>
            {mode === "login" ? "Sign in" : "Create account"}
          </button>
          <button
            className="btn secondary"
            type="button"
            onClick={() => setMode(mode === "login" ? "register" : "login")}
          >
            {mode === "login" ? "I need an account" : "I already have an account"}
          </button>
        </form>
        <Note>Demo accounts: anders@talklight.test and admin@talklight.test, password talklight-demo.</Note>
      </div>
    </>
  );
}
